import React, { useState } from 'react';
import { HeaderBookACall } from '../components/heylloyd/HeaderBookACall';
import { HeroSectionBookACall } from '../components/heylloyd/HeroSectionBookACall';
import { Calendar, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HeyLloydBookACallPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <div className="min-h-screen bg-black font-sans text-white selection:bg-[#7FFF00]/20 selection:text-[#7FFF00]" data-id="element-800">
      <HeaderBookACall data-id="element-801" />
      <div id="hero" data-id="element-802">
        <HeroSectionBookACall data-id="element-803" />
      </div>

      {/* Book a Call CTA Section */}
      <section id="beneficios" className="py-12 md:py-20 lg:py-28 bg-gradient-to-b from-black to-gray-900" data-id="element-804">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-805">
          <div className="mb-6 md:mb-10" data-id="element-806">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-5 tracking-tight px-2" data-id="element-807">
              Únete a la Revolución de la IA
              <span className="block text-[#7FFF00] mt-2" data-id="element-808">
                Más Fácil que Nunca
              </span>
            </h2>
            <p className="text-base md:text-lg text-gray-100 max-w-2xl mx-auto leading-relaxed px-2" data-id="element-809">
              Habla con nuestro equipo y descubre cómo implementar inteligencia
              artificial en tu negocio para crear y escalar productos digitales
              de forma profesional.
            </p>
          </div>

          <div id="proceso" className="bg-gray-900 rounded-2xl shadow-xl border border-gray-800 p-5 md:p-8 mb-6 max-w-2xl mx-auto" data-id="element-810">
            <div className="space-y-5" data-id="element-811">
              <div className="flex items-start gap-4 text-left" data-id="element-812">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-813">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-814">
                    1
                  </span>
                </div>
                <div data-id="element-815">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-816">
                    Agenda tu llamada estratégica
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-817">
                    Elige el horario que mejor se ajuste a tu agenda
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 text-left" data-id="element-818">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-819">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-820">
                    2
                  </span>
                </div>
                <div data-id="element-821">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-822">
                    Consulta con expertos en IA
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-823">
                    Nuestro equipo analizará tu caso y te mostrará cómo aplicar
                    IA a tu negocio específico
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 text-left" data-id="element-824">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-825">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-826">
                    3
                  </span>
                </div>
                <div data-id="element-827">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-828">
                    Recibe tu plan de acción
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-829">
                    Obtén una estrategia personalizada para implementar IA y
                    empezar a ver resultados
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-800" data-id="element-830">
              <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" data-id="element-831">
                <Button variant="primary" size="lg" className="w-full text-base md:text-lg px-6 py-5 md:py-6 bg-[#7FFF00] hover:bg-[#6FEF00] text-black font-bold shadow-lg shadow-[#7FFF00]/20 hover:shadow-xl hover:shadow-[#7FFF00]/30" leftIcon={<Calendar className="w-5 h-5 md:w-6 md:h-6" data-id="element-833" />} data-id="element-832">
                  Agenda tu Llamada Estratégica Gratis
                </Button>
              </a>
              <p className="text-sm text-gray-200 mt-4" data-id="element-834">
                Sin compromiso • Sesión de 30 minutos • Estrategia personalizada
              </p>
            </div>
          </div>

          <div id="resultados" className="grid grid-cols-3 gap-3 md:gap-6 max-w-3xl mx-auto" data-id="element-835">
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-836">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-837">
                100+
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-838">
                Negocios transformados con IA
              </p>
            </div>
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-839">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-840">
                95%
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-841">
                Clientes satisfechos
              </p>
            </div>
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-842">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-843">
                24/7
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-844">
                Soporte continuo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-900" data-id="element-845">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-846">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-847">
            <p data-id="element-848">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-849">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-850">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-851">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-852">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-853">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-900" data-id="element-854">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-855">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-856">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] transition-colors" data-id="element-857">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-858">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-859">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-860">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-861">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-862">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative border border-gray-800" onClick={e => e.stopPropagation()} data-id="element-863">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-864">
              <X className="w-6 h-6" data-id="element-865" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-866">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-867">
              <p data-id="element-868">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-869">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-870">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-871">
                2. Uso del Servicio
              </h3>
              <p data-id="element-872">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-873">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-874">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-875">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-876">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-877">
                5. Modificaciones
              </h3>
              <p data-id="element-878">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-879">Contacto</h3>
              <p data-id="element-880">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-881">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-882">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative border border-gray-800" onClick={e => e.stopPropagation()} data-id="element-883">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-884">
              <X className="w-6 h-6" data-id="element-885" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-886">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-887">
              <p data-id="element-888">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-889">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-890">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-891">
                <li data-id="element-892">Nombre y dirección de correo electrónico</li>
                <li data-id="element-893">Información de registro del evento</li>
                <li data-id="element-894">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-895">
                2. Uso de la Información
              </h3>
              <p data-id="element-896">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-897">
                <li data-id="element-898">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-899">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-900">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-901">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-902">
                3. Compartir Información
              </h3>
              <p data-id="element-903">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-904">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-905">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-906">
                5. Tus Derechos
              </h3>
              <p data-id="element-907">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-908">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-909">6. Cookies</h3>
              <p data-id="element-910">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-911">Contacto</h3>
              <p data-id="element-912">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-913">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}